module.exports = __webpack_public_path__ + "img/vocabulary.c581aadf.svg";